<template>
  <!-- 订单详情地址信息 -->
  <div class="address_con" @click="goAddressList">
    <div
      v-if="!isAllow && addressConstant"
      class="not_add font12 font_weight400 line_height_17"
    >
      <img src="@/assets/order/icon_warning@2x.png" alt="" />
      <span>{{ addressConstant }}</span>
    </div>
    <div class="con_left">
      <div v-if="address.province">
        <div class="font12 font_weight400 colo087 line_height_17 text_left">
          <span
            v-if="address.isDefault"
            class="add_default font_weight400 font10 colof"
            >默认</span
          >
          <span
            >{{ address.province }} {{ address.city }}
            {{ address.district }}</span
          >
        </div>
        <div
          class="font18 font_weight600 colo087 line_height_21 text_left add_add"
        >
          {{ address.addressLine }}
        </div>
        <div
          class="text_left font12 font_weight400 colo087 line_height_14 add_name"
        >
          {{ address.name }} {{ address.phone }}
        </div>
      </div>
      <div v-else class="text_left font14 font_weight500 colo087">
        请选择收货地址
      </div>
      <div v-if="showGoArrow">
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="icon_right"
        />
      </div>
    </div>
    <!-- <div class="botom_line"></div> -->
    <img src="@/assets/common/address_line@2x.png" alt="" class="add_line" />
  </div>
</template>
<script>
export default {
  props: {
    showDefault: {
      type: Boolean,
      default: true
    },
    showGoArrow: {
      type: Boolean,
      default: true
    },
    address: {
      type: Object,
      default() {
        return {};
      }
    },
    isAllow: {
      type: Number,
      default: 0
    },
    addressConstant: {
      type: String,
      default: ""
    }
  },
  watch: {
    address() {
      // console.log(this.address, "11222211watch");
    }
  },
  // mounted() {
  //   console.log(this.address, 334343);
  // },
  data() {
    return {};
  },
  methods: {
    goAddressList() {
      this.$emit("goAddressList");
    }
  }
};
</script>

<style lang="less" scoped>
.address_con {
  background: #fff;
  border-radius: 8px 8px 0 0;
  position: relative;
  // padding: 12px 12px 0;
  .not_add {
    display: flex;
    color: #dd9132;
    align-items: center;
    padding: 10px 12px;
    background: #fcf8d9;
    img {
      width: 16px;
      height: 16px;
      display: block;
      margin-right: 12px;
    }
  }
  .con_left {
    padding: 12px 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon_right {
    width: 24px;
  }
  .add_default {
    background: #bf9264;
    border-radius: 2px;
    padding: 0 2px;
    margin-right: 12px;
  }
  .add_name {
    padding: 12px 0 19px 0;
  }
  .add_add {
    margin-top: 12px;
  }
  .add_line {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    display: block;
    width: 100%;
    height: 3px;
  }
}
</style>
